module.exports = __webpack_public_path__ + "6cfe56f231a62b12f77f08e54c2b0c90.MP3";